<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button id="goToTopBtn" mat-fab type="button" class="btn active" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </div>
